const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-fracking/shared/lib/crew-operationstatus-options-registry");